/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Period of stay
 * @export
 * @interface BookingInfoDto
 */
export interface BookingInfoDto {
    /**
     * Check-in date and time according to local hotel time.<br />
     * The format complies with ISO-8601 YYYY-MM-DDThh:mm
     * @type {string}
     * @memberof BookingInfoDto
     */
    arrivalDateTime: string;
    /**
     * Check-out date and time according to local hotel time.<br />
     * The format complies with ISO-8601 YYYY-MM-DDThh:mm
     * @type {string}
     * @memberof BookingInfoDto
     */
    departureDateTime: string;
    /**
     * Количество взрослых
     * @type {number}
     * @memberof BookingInfoDto
     */
    adults: number;
    /**
     * Возраст детей
     * @type {Array<number>}
     * @memberof BookingInfoDto
     */
    childAges?: Array<number> | null;
}

/**
 * Check if a given object implements the BookingInfoDto interface.
 */
export function instanceOfBookingInfoDto(value: object): value is BookingInfoDto {
    if (!('arrivalDateTime' in value) || value['arrivalDateTime'] === undefined) return false;
    if (!('departureDateTime' in value) || value['departureDateTime'] === undefined) return false;
    if (!('adults' in value) || value['adults'] === undefined) return false;
    return true;
}

export function BookingInfoDtoFromJSON(json: any): BookingInfoDto {
    return BookingInfoDtoFromJSONTyped(json, false);
}

export function BookingInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'arrivalDateTime': json['arrivalDateTime'],
        'departureDateTime': json['departureDateTime'],
        'adults': json['adults'],
        'childAges': json['childAges'] == null ? undefined : json['childAges'],
    };
}

  export function BookingInfoDtoToJSON(json: any): BookingInfoDto {
      return BookingInfoDtoToJSONTyped(json, false);
  }

  export function BookingInfoDtoToJSONTyped(value?: BookingInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'arrivalDateTime': value['arrivalDateTime'],
        'departureDateTime': value['departureDateTime'],
        'adults': value['adults'],
        'childAges': value['childAges'],
    };
}

